import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerService } from './spinner.service';
import { SpinnerComponent } from './spinner.component';
 
@NgModule({
  imports: [CommonModule],
  exports: [],
  declarations: [SpinnerComponent],
  entryComponents: [SpinnerComponent], //THIS IS IMPORTANT!!!!
  providers: [SpinnerService]
})
export class SpinnerModule { }


// WEBPACK FOOTER //
// ./src/app/_services/spinner.module.ts